export const LATEST_ARTICLES_REQUEST = 'LATEST_ARTICLES_REQUEST';
export const LATEST_ARTICLES_SUCCESS = 'LATEST_ARTICLES_SUCCESS';
export const LATEST_ARTICLES_FAILURE = 'LATEST_ARTICLES_FAILURE';

export const PLUSS_ARTICLES_REQUEST = 'PLUSS_ARTICLES_REQUEST';
export const PLUSS_ARTICLES_SUCCESS = 'PLUSS_ARTICLES_SUCCESS';
export const PLUSS_ARTICLES_ADD = 'PLUSS_ARTICLES_ADD';
export const PLUSS_ARTICLES_FAILURE = 'PLUSS_ARTICLES_FAILURE';

export const COLLECTION_ARTICLES_REQUEST = 'COLLECTION_ARTICLES_REQUEST';
export const COLLECTION_ARTICLES_SUCCESS = 'COLLECTION_ARTICLES_SUCCESS';
export const COLLECTION_ARTICLES_ADD = 'COLLECTION_ARTICLES_ADD';
export const COLLECTION_ARTICLES_FAILURE = 'COLLECTION_ARTICLES_FAILURE';

export const RECIRCULATION_REQUEST = 'RECIRCULATION_REQUEST';
export const RECIRCULATION_SUCCESS = 'RECIRCULATION_SUCCESS';
export const RECIRCULATION_FAILURE = 'RECIRCULATION_FAILURE';

export const COUPON_CODES_REQUEST = 'COUPON_CODES_REQUEST';
export const COUPON_CODES_SUCCESS = 'COUPON_CODES_SUCCESS';
export const COUPON_CODES_FAILURE = 'COUPON_CODES_FAILURE';

export const SWITCH_DEVICE = 'SWITCH_DEVICE';

export const UTM_PARAMS = 'UTM_PARAMS';

export const PAYWALL_TYPE = 'PAYWALL_TYPE';



/** WEBPACK FOOTER **
 ** ./src/redux/actions/types.js
 **/